import {useState, type FC} from 'react'
import InviteColleague from '../homepage/InviteColleague'
import UniversalHiddenScreen from '../universal-components/hidden-screen/UniversalHiddenScreen'
import classes from './Knowledge.module.scss'
import KnowledgeForm from './components/KnowledgeForm'

import {useFindOneKnowledgeQuery} from '../../../services/knowledgeServiceApi'

interface KnowledgeProps {}

const Knowledge: FC<KnowledgeProps> = () => {
  const [visibleBackground, setVisibleBackground] = useState(false)

  const {data: knowledge, refetch} = useFindOneKnowledgeQuery({})

  const handleVisibility = () => {
    setVisibleBackground((prev) => !prev)
  }

  return (
    <div className={classes.members}>
      <UniversalHiddenScreen
        visible={visibleBackground}
        handleVisibility={handleVisibility}
        contentBlock={<InviteColleague handleVisibility={handleVisibility} />}
      />

      <div className='w-100'>
        <div className='row'>
          <div className='col-lg-1'></div>
          <div className='col-lg-10'>
            <KnowledgeForm refetch={refetch} data={knowledge} />
          </div>
          <div className='col-lg-1'></div>
        </div>
      </div>
    </div>
  )
}

export default Knowledge
